import {css} from '@emotion/react'
import {useAiContext} from '@/biz/ai'

const cssTemplate = css({
    fontSize: '1.2em',
    fontWeight: 'bold',
})

export const Template = (props) => {
    const ai = useAiContext()

    if (! ai.template) {
        return <div></div>
    }

    const {promptTemplateName, llmName, llmProviderName} = ai.template

    return (
        <div
            css={cssTemplate}
            {...props}
        >
            {promptTemplateName} - {llmProviderName}/{llmName}
        </div>
    )
}
